import type {
  KPAstrologyRequest,
  KPAstrologyResponse,
  PlanetKPInfo,
  SubLordInfo,
} from "@ishvaram/api-client";
import { apiRequest } from "./_fetch";

export type { KPAstrologyRequest, KPAstrologyResponse, PlanetKPInfo, SubLordInfo };

export async function calculateKPAstrology(data: KPAstrologyRequest): Promise<KPAstrologyResponse> {
  return apiRequest<KPAstrologyResponse>("/kp-astrology", {
    method: "POST",
    body: JSON.stringify(data),
  });
}
